import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import {
  viewCancellationPolicy,
  updateCancellationPolicy,
} from "../../Redux/Actions/cancellationPoliciesAction";
import { ToFirstCapital } from "../../Utils/helpers";
import SearchBar from "../Main/searchBar";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import "./view.css"; 

const ViewCancellationPolicy = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const policyState = useSelector((state) => state.cancellationPolicies || {});

  const [status, setStatus] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    if (id) dispatch(viewCancellationPolicy(id));
    else console.warn("No cancellation policy ID found in URL");
  }, [dispatch, id]);

  useEffect(() => {
    if (policyState.policy?.status) {
      setStatus(policyState.policy.status);
    }
  }, [policyState.policy]);

  const data = policyState.policy || {};

  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
    setShowConfirm(true);
  };

  const confirmStatusChange = () => {
    setIsUpdating(true);
    setShowConfirm(false);
    dispatch(updateCancellationPolicy({ id: data._id, status: selectedStatus })).finally(() =>
      setIsUpdating(false)
    );
  };

  return (
    <div className="view-voucher-container"> {/* reuse reward styles */}
      <div className="view-voucher-grid padding-20 gap-10 grid-container">
        <div style={{ gridColumn: "3/8" }}>
          <SearchBar style={{ width: "max-content" }} />
        </div>

        <div className="view-voucher-header back-icon margin-0 gap-10 align-center flex-container">
          <Link to="/cancellation_policies">
            <BackIcon style={{ cursor: "pointer" }} />
          </Link>
          <div className="view-voucher-title-section referral-view">
            <h3 className="view-voucher-main-title">Cancellation Policy Details</h3>
            <h4 className="view-voucher-breadcrumb">Cancellation Policies / List / View</h4>
          </div>
        </div>

        <div className={`view-voucher-content overall-container ${isUpdating ? "updating" : ""}`}>
          <div className="voucher-info-grid">
            <div className="voucher-info-item">
              <span className="voucher-info-label">Title</span>
              <h2 className="voucher-info-value">{data.title || "No Data"}</h2>
            </div>

            <div className="voucher-info-item">
              <span className="voucher-info-label">Type</span>
              <h2 className="voucher-info-value">{ToFirstCapital(data.type) || "No Data"}</h2>
            </div>

            <div className="voucher-info-item full-width">
              <span className="voucher-info-label">Policy</span>
              <ul className="voucher-list">
                {(data.policy || []).length > 0 ? (
                  data.policy.map((item, idx) => (
                    <li key={idx} className="voucher-list-item">{item}</li>
                  ))
                ) : (
                  <li className="voucher-no-data">No Data</li>
                )}
              </ul>
            </div>
          </div>

          {/* You can enable status dropdown and confirm modal if your app manages status changes */}
          {/*
          <div className="voucher-status-section">
            <div className="voucher-status-wrapper">
              <span className="voucher-status-label">Status</span>
              <select
                value={status}
                onChange={handleStatusChange}
                className="voucher-status-select"
                disabled={isUpdating}
              >
                <option value="" disabled>Select Status</option>
                {["active", "inactive"].map(stat => (
                  <option key={stat} value={stat}>{ToFirstCapital(stat)}</option>
                ))}
              </select>
              {isUpdating && <p className="voucher-updating-text">Updating status...</p>}
            </div>
          </div>

          {showConfirm && (
            <div className="voucher-modal-backdrop">
              <div className="voucher-modal-content">
                <p className="voucher-modal-text">
                  Are you sure you want to change status to "{ToFirstCapital(selectedStatus)}"?
                </p>
                <div className="voucher-modal-buttons">
                  <button
                    onClick={confirmStatusChange}
                    disabled={isUpdating}
                    className="voucher-modal-btn voucher-modal-btn-yes"
                  >
                    Yes
                  </button>
                  <button
                    onClick={() => setShowConfirm(false)}
                    disabled={isUpdating}
                    className="voucher-modal-btn voucher-modal-btn-no"
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          )}
          */}
        </div>
      </div>
    </div>
  );
};

export default ViewCancellationPolicy;
